export const convertExponentialToDecimal = (expNotation) => {
    const num = Number(expNotation);
    if (!isFinite(num)) {
        return '';
    }
    if (!num.toString().includes('e')) {
        return expNotation;
    }
    let decimalPlaces;
    if (num === 0) {
        decimalPlaces = 10;
    }
    else {
        decimalPlaces = Math.max(0, Math.ceil(-Math.log10(Math.abs(num))));
    }
    return num.toFixed(decimalPlaces);
};
//# sourceMappingURL=convertExponentialToDecimal.js.map